import t from "react";
import { ark as c } from "@ark-ui/react";
import { styled as s } from "@huspy/styled-system/jsx";
import { iconButton as l } from "@huspy/styled-system/recipes";
const n = {
  sm: "16px",
  md: "16px",
  lg: "20px"
}, p = s(c.button, l), h = (r) => {
  const { children: i, ...o } = r, m = t.Children.map(i, (e) => t.isValidElement(e) ? t.cloneElement(e, {
    // @ts-ignore
    width: n[o.size],
    // @ts-ignore
    height: n[o.size],
    color: "currentColor"
  }) : e);
  return /* @__PURE__ */ t.createElement(p, { ...o }, m);
};
export {
  p as CustomIconButton,
  h as IconButton
};
